import React from "react";

export class Popup extends React.Component {
    render() {
        return (
            <div className="popup">
                <img src="" alt="" className="popup__image" />
                <button className="popup__close-button">&#10005;</button>
            </div>
        );
    }
}
